<ng-container *ngIf="showError; else showspinner">
  <ng-container *ngIf="errorMsg; else fallback">
    <div [innerHtml]="errorMsg | safeHtml"></div>
  </ng-container>
  <ng-template #fallback>
    <p>Our apologies. We are having difficulty retrieving your information. Please try again later.</p>
  </ng-template>
</ng-container>
<ng-template #showspinner>
  <p><span class="fa fa-spinner fa-pulse fa-fw"></span></p>
</ng-template>